import React, { useLayoutEffect } from 'react';
import ReactGa from 'react-ga4';
import GimpoNewIntroduceMobile from './designcomponents/gimpo_newintroducemobile';

export default function GimpoNewIntroduce() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    ReactGa.send({ hitType: 'pageview', page_title: 'gimpo_newintroduce' });
  }, []);
  return <GimpoNewIntroduceMobile />;
}
